export const FALLBACK_COLOR = '#242f44' // $c-primary-l
export const CLEAN_SESSION_TIMEOUT = 2500

export const BASE_CLASS = 'mt-UserProfile'
export const INFO_CLASS = `${BASE_CLASS}-info`
export const INFO_TITLE_CLASS = `${INFO_CLASS}Title`
export const INFO_AVATAR_CLASS = `${INFO_CLASS}Avatar`
export const INFO_BUTTON_CLASS = `${INFO_CLASS}Button`
export const PANEL_CLASS = `${BASE_CLASS}-panel`
export const SECTION_CLASS = `${PANEL_CLASS}Section`
export const CONSENTS_CLASS = `${SECTION_CLASS}Consents`
export const CONSENTS_INNER_CLASS = `${SECTION_CLASS}ConsentsInner`
export const PRIVACY_ACTIONS_CLASS = `${SECTION_CLASS}PrivacyActions`
export const NOTIFICATION_WRAPPER_CLASS = `${BASE_CLASS}-notificationWrapper`
export const NOTIFICATION_TEXT_CLASS = `${BASE_CLASS}-notificationText`
export const CONSENT_LINK_CLASS = `${BASE_CLASS}-consentLink`
export const MOLECULE_MODAL_CONTENT_TEXT_CLASS = `${BASE_CLASS}-modalContentText`
